import {
  useEventEmitter as originalUseEventEmitter,
  useInstance as originalUseInstance,
  useService as originalUseService,
  type MintServices,
  type ServiceConfig,
} from '@mint-lib/routing-context';
import {
  ServiceEventsArgs,
  ServiceEventsNames,
  ServicesNames,
  type ServiceArgs,
  type ServiceInstance,
} from '@mint-lib/service-locator';

import type { MintAdminServices } from '../types.js';

export const useEventEmitter = originalUseEventEmitter as <
  Service extends ServicesNames<MintAdminServices>,
  Events extends ServiceEventsNames<
    MintAdminServices,
    Service,
    ServiceArgs<MintAdminServices, Service>
  >,
  Args extends ServiceEventsArgs<
    MintAdminServices,
    Service,
    ServiceArgs<MintAdminServices, Service>,
    Events
  >,
>(
  key: Service,
  event: Events,
) => (...args: Args) => void;

export const useInstance = originalUseInstance as <
  Key extends ServicesNames<MintAdminServices>,
  Args extends ServiceArgs<MintAdminServices, Key>,
  Service extends ServiceInstance<MintAdminServices, Key, Args>,
>(
  name: Key,
  ...args: ServiceArgs<MintAdminServices, Key>
) => [Service | null, number];

export const useService = originalUseService as <
  Config extends ServiceConfig<Key, Args>,
  Key extends ServicesNames<MintServices> = Config['name'],
  // @ts-expect-error TS2344 Key is correctly inferred
  Args extends ServiceArgs<MintServices, Key> = Config['args'],
  Service extends ServiceInstance<MintServices, Key, Args> = ServiceInstance<
    MintServices,
    Key,
    Args
  >,
>(
  config: Config,
) => [Config['failOnNotFound'] extends true ? Service : Service | null, number];

export { useRequest, useFlags } from '@mint-lib/routing-context';
